module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/heart-icon-a328c266764b4d1143b2a5e0247b6b4c.png";